// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LQFwX","tabsBox":"styles_tabsBox__3XP_x","createButton":"styles_createButton__2sVeP"};